export function formatConnection(phases = []) {
  return phases.length > 1 ? phases.join('-') : `${phases[0]}-N`
}

export function formatNumber(value) {
  return typeof value === 'number' ? Number(value.toFixed(4)) : '-'
}

export function formatStepRange(step, demand) {
  const unit = demand.ruleType === 'quantity' ? 'aparelhos' : demand.ruleUnit
  const upTo = step.upTo === null ? 'excedente' : `${step.upTo}`

  return step.upTo === null ? `acima de ${step.from} ${unit}` : `${step.from} a ${upTo} ${unit}`
}

export const IDR_SCOPE_LABELS = { general: 'Geral', group: 'Grupo', individual: 'Individual' }
export const IDR_REASONS = {
  'idr-capacity-exceeded': 'a corrente requerida excede o maior IDR do catálogo (125 A).',
  'terminal-sizing-unavailable':
    'um circuito vinculado não pôde ser dimensionado, então o IDR não pôde ser selecionado.',
}

export function formatIdr(idr) {
  if (idr.status === 'no-load') return 'Sem carga'
  if (idr.nominalCurrent === null || idr.nominalCurrent === undefined) return 'Indisponível'
  return `${idr.nominalCurrent} A (${idr.poleType} · ${idr.poles} polos)`
}

export function formatProtection(protection) {
  if (protection.status === 'no-load') return 'Sem carga'
  // Sem calibre na tabela de disjuntores (breaker-capacity-exceeded).
  if (!protection.breaker) return 'Acima da tabela (100 A)'
  return `${protection.breaker.current} A (${protection.poles} polo${protection.poles > 1 ? 's' : ''})`
}

export function formatWire(protection) {
  if (protection.wire) return protection.wire.name
  if (protection.status === 'out-of-range' && protection.reason === 'wire-capacity-exceeded') {
    return 'Nenhum cabo suporta o disjuntor'
  }
  return '-'
}

// Memória do dimensionamento do cabo de alimentação; cada item vira uma linha.
export function formatWireDetails(protection) {
  const { wire, conductor, grouping } = protection
  const lines = []

  if (wire) {
    lines.push(`Capacidade: ${formatNumber(wire.ampacity)} A (corrigida: ${formatNumber(wire.correctedAmpacity)} A)`)
  }

  if (conductor) {
    if (conductor.loadedConductors !== undefined) {
      lines.push(
        `Condutores carregados: ${conductor.loadedConductors} (coluna de ${conductor.tableLoadedConductors ?? conductor.loadedConductors})`
      )
    }

    lines.push(
      `NBR 5410, tabela ${conductor.table}, coluna ${conductor.column} · ${conductor.method} · ${conductor.insulation} (${conductor.conductorTemperature} °C)`
    )
  }

  if (grouping) {
    lines.push(
      `Agrupamento (tabela 42): caso ${grouping.reference}, ${grouping.circuitCount} circuito${grouping.circuitCount === 1 ? '' : 's'}, fator ${formatNumber(grouping.factor)}`
    )
  }

  return lines
}

export function incompleteReason(protection) {
  if (protection.reason === 'wire-capacity-exceeded') {
    return 'há disjuntor na tabela, mas nenhum cabo suporta esse calibre após os fatores de correção.'
  }

  if (protection.reason === 'terminal-sizing-unavailable') {
    return 'algum circuito terminal não pôde ser dimensionado, então a alimentação não pode ser concluída.'
  }

  return 'a corrente de projeto excede o maior disjuntor da tabela (100 A).'
}

export function isIncomplete(protection) {
  return protection.status === 'out-of-range'
}

export function orderBoardsAsTree(boards) {
  const rows = []

  function visit(parentId, depth, path) {
    boards
      .filter((board) => board.parentId === parentId)
      .forEach((board) => {
        const boardPath = [...path, board.name]
        rows.push({ board, depth, path: boardPath })
        visit(board.id, depth + 1, boardPath)
      })
  }

  visit(null, 0, [])

  return rows
}
